export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/nav-logo.bcb799eb.svg","height":271,"width":906,"blurWidth":0,"blurHeight":0};